import { Badge } from '@ibsys/kit';
import { Tooltip } from '@/shared/ui';
import type { FC } from 'react';
import { cn } from '@/shared/lib';

type Props = {
  /** Метка тега — какие персональные данные скрыты (например, «Имя») */
  label: string;
  /** Исходное значение; не задано — тег нераскрываемый */
  value?: string;
};

/**
 * Оформление блока: цвет наследуется от текста реплики (currentColor), поэтому блок читается
 * одинаково и в облаке консультанта, и в облаке клиента; фон и рамка — производные того же цвета.
 */
const BADGE_CLASS_NAME =
  'mx-0.5 px-1.5 py-0 align-baseline text-2xs font-normal text-current bg-current/10 border-current/40';

/**
 * Блок на месте скрытых анонимизацией персональных данных в реплике.
 * Исходное значение раскрывается по наведению и только когда оно пришло с транскриптом.
 */
export const AnonymizationTagBadge: FC<Props> = ({ label, value }) => {
  if (!value) {
    return (
      <Badge variant="secondary" outline className={BADGE_CLASS_NAME}>
        {label}
      </Badge>
    );
  }

  return (
    <Tooltip tooltip={value}>
      <Badge variant="secondary" outline className={cn(BADGE_CLASS_NAME, 'cursor-help')} tabIndex={0}>
        {label}
      </Badge>
    </Tooltip>
  );
};
